module.exports = __webpack_public_path__ + "static/media/date_arrow.397dec1c.svg";